/*
 * DISTRIBUTION STATEMENT C. Distribution authorized to U.S. Government Agencies and their contractors; Critical
 * Technology; 19 October 2017. Other requests for this document shall be referred to Chemical and Biological
 * Technologies, Defense Threat Reduction Agency, 8725 John J Kingman Road, Fort Belvoir, VA 22060-6201.
 *
 * WARNING: This document contains technical data whose export is restricted by the Arms Export Control Act (Sec 2751
 * of Title 22, United States Code) or the Export Control Reform Act of 2018 (Chapter 58 Sections 4801-4852 of Title
 * 50, United States Code). Violations of these export laws are subject to severe criminal penalties. Disseminate in
 * accordance with provisions of DoD Directive 5230.25 and DoD Instruction 2040.02. DESTRUCTION NOTICE: For
 * unclassified, limited distribution documents, destroy by any method that will prevent disclosure of the contents
 * or reconstruction of the document.
 *
 * This material is based upon work supported by the Under Secretary of War for Research and Engineering under Air
 * Force Contract No. FA8702-15-D-0001 or FA8702-25-D-B002. Any opinions, findings, conclusions or recommendations
 * expressed in this material are those of the author(s) and do not necessarily reflect the views of the Under
 * Secretary of War for Research and Engineering.
 *
 * © 2026 Massachusetts Institute of Technology.
 *
 * The software/firmware is provided to you on an As-Is basis
 *
 * Delivered to the U.S. Government with Unlimited Rights, as defined in DFARS Part 252.227-7013 or 7014 (Feb 2014).
 * Notwithstanding any copyright notice, U.S. Government rights in this work are defined by DFARS 252.227-7013 or
 * DFARS 252.227-7014 as detailed above. Use of this work other than as specifically authorized by the U.S.
 * Government may violate any copyrights that exist in this work.
 *
 * This document contains Controlled Unclassified Information (CUI). Handling of this information is subject to the
 * controls identified in DFARS 252.204-7012 - SAFEGUARDING COVERED DEFENSE INFORMATION AND CYBER INCIDENT REPORTING.
 */

// React imports
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Material-UI
import { makeStyles } from 'tss-react/mui';

// React-Bootstrap
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button';

// Images
import studyIcon from '../assets/images/Icons_Study_Small.png';
import { AiOutlineFolder } from 'react-icons/ai';

// Banner types: info, warning
const useStyles = makeStyles()({
  info: {
    color: 'white',
    backgroundColor: '#003E65',
    backgroundImage: 'linear-gradient(to right, #003E65 50%, #0c89d7)',
    padding: '24px 30px 28px 20px',
    width: 'auto',
    maxWidth: '1900px',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.06)',
    fontSize: '15px'
  },
  warning: {
    color: 'black',
    backgroundColor: '#FFAF13',
    backgroundImage: 'linear-gradient(to right, #ffed42, #FFAF13 90%)',
    padding: '24px 30px 28px 20px',
    width: 'auto',
    maxWidth: '1900px',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.06)',
    fontSize: '15px'
  },
  banner: {
    width: '100%', 
    padding: '40px'
  },
  actionCol: {
    minWidth: '120px',
    margin: 'auto',
    width: '50%',
    textAlign: 'center'
  },
  imageCol: {
    minWidth: '120px'
  },
  image: {
    width: '80px', 
    maxHeight: '100%', 
    margin: '0 15px'
  },
  title: {
    marginLeft: 0,
    paddingLeft: 0
  }
});

export function Banner({type='info', title='Banner Title', message='Body Text', actionButton, image, ...props}) {
  const { classes } = useStyles();
  let location = useLocation();

  const [wrapperColor, setWrapperColor] = useState('rgba(0,0,0,0)');

  useEffect(() => {
    if (location?.pathname === '/home') {
      setWrapperColor('#001B2C');
    } else {
      setWrapperColor('rgba(0,0,0,0)');
    }
  }, [location, wrapperColor])

  let imageCol = image ? (
    <Col xs={1} className={classes.imageCol}>
      <div>
        <img src={image} className={classes.image} alt='' />
      </div>
    </Col>
    ) : (<Col xs={1} />);

  let actionCol = actionButton ? (
    <Col className={classes.actionCol}>
      {actionButton}
    </Col>
    ) : (<></>);

  return (
    <div className={classes.banner} style={{ backgroundColor: wrapperColor }}>
      <Container className={classes[type]}>
        <Row>
          {imageCol}
          <Col xs={9}>
            <Row>
              <h4 className={classes.title}>{title}</h4>
            </Row>
            <Row>
              {message}
            </Row>
          </Col>
          {actionCol}
        </Row>
      </Container>
    </div>
  );
}

export default Banner;